@if (assessable()) {
	@for (group of assessable().assessableGroups; track group.groupId; let groupIndex = $index) {
		@if (isGroupVisible(group)) {
			<div class="group">
				<div class="groupName" [class.active]="group.groupId === activeGroupId()" (click)="onGroupClickedHandler(group.groupId)">
					<span class="indent">{{ groupIndex + 1 }}.</span>
					@if (errorIds()?.includes(group.groupId)) {
						<mat-icon fontSet="fad" fontIcon="fa-exclamation-triangle" inline color="warn" class="prefixIcon" />
					}
					<span>
						{{ group.name }}
					</span>
				</div>
				@for (item of group.items; track item.assessableItemId; let itemIndex = $index) {
					<div
						class="itemName"
						[class.active]="item.assessableItemId === activeItemId()"
						(click)="
							onItemClickedHandler({
								groupId: group.groupId,
								itemId: item.assessableItemId,
							})
						"
					>
						<span class="indent">{{ groupIndex + 1 }}.{{ itemIndex + 1 }}.</span>
						@if (errorIds()?.includes(item.assessableItemId)) {
							<mat-icon
								fontSet="fad"
								@zoomInOnEnter
								@zoomOutOnLeave
								fontIcon="fa-exclamation-triangle"
								inline
								color="warn"
								class="prefixIcon"
							/>
						}
						@if (showImportedItems && AssessablePanelType.Assessment && $any(item)?.fromCatalogueId) {
							<mat-icon fontSet="fad" @zoomInOnEnter @zoomOutOnLeave fontIcon="fa-file-import" inline class="prefixIcon" />
						}

						@let answerIsArray = Array.isArray(item.answer);
						@let answerIsDefined = item.answer !== null && item.answer !== undefined;

						@if ((!answerIsArray && answerIsDefined) || (answerIsArray && item.answer.length > 0)) {
							<mat-icon fontSet="fad" @zoomInOnEnter @zoomOutOnLeave fontIcon="fa-check" inline class="prefixIcon" />
						}
						<sim-safe-html [html]="item.title" />
					</div>
				}
			</div>
		}
	}

	@let checklist = assessable() | typeGuard: GeneratedTypePredicates.isChecklist;
	@if (checklist && checklist.ungroupedItems.length > 0) {
		<div class="group">
			<div class="groupName" (click)="onUngroupedGroupClicked()" [class.active]="isUngroupedItemGroupActive()">
				<span class="indent">{{ checklist.assessableGroups.length + 1 }}.</span>
				{{ nonGroupedItemsHeaderLocalizationKey | translate }}
			</div>
			@for (item of checklist.ungroupedItems; track item.assessableItemId; let itemIndex = $index) {
				<div
					class="itemName"
					[class.active]="item.assessableItemId === activeItemId()"
					(click)="
						onItemClickedHandler({
							groupId: null,
							itemId: item.assessableItemId,
						})
					"
				>
					<span class="indent">{{ assessable().assessableGroups.length + 1 }}.{{ itemIndex + 1 }}.</span>
					<sim-safe-html [html]="item.title" />
				</div>
			}
		</div>
	}
}
